(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbp-demo-01"]) return;
  try {
    
// Only upgrades WBP's dedicated media elements. No global theme selectors.
if (!customElements.get('wbp-motion-media')) {
  customElements.define('wbp-motion-media', class extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template[data-wbp-motion]');
      this.button = this.querySelector('[data-wbp-toggle]');
      if (!this.template || !this.button || this.events) return;
      this.events = new AbortController();
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.near = false;
      this.userPaused = false;
      this.userRequested = false;
      this.blocked = false;
      this.preferenceChanged = () => { this.userRequested = false; this.sync(); };
      this.preference.addEventListener('change', this.preferenceChanged);
      document.addEventListener('visibilitychange', () => this.sync(), { signal: this.events.signal });
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        if (this.hasAttribute('data-playing')) {
          this.userPaused = true;
          this.userRequested = false;
        } else {
          this.userPaused = false;
          this.userRequested = true;
          this.blocked = false;
          this.near = true;
        }
        this.sync();
      }, { signal: this.events.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.near = entries[0].isIntersecting;
          this.sync();
        }, { rootMargin: '80px 0px', threshold: 0.01 });
        this.observer.observe(this);
      }
      this.label();
    }
    shouldPlay() {
      return this.isConnected && this.near && !document.hidden && !this.userPaused && !this.blocked &&
        (!this.preference.matches || this.userRequested);
    }
    label() {
      const playing = this.hasAttribute('data-playing');
      this.button.textContent = playing ? 'Animation pausieren' : 'Animation abspielen';
      this.button.setAttribute('aria-label', this.button.textContent);
    }
    stop() {
      this.removeAttribute('data-playing');
      if (this.media?.tagName === 'VIDEO') { this.media.autoplay = false; this.media.pause(); }
      else if (this.media) { this.media.remove(); this.media = null; }
      this.label();
    }
    sync() {
      if (!this.shouldPlay()) { this.stop(); return; }
      if (!this.media) {
        this.media = this.template.content.firstElementChild.cloneNode(true);
        this.media.classList.add('wbp-motion__live');
        if (this.media.tagName === 'VIDEO') {
          this.media.muted = true;
          this.media.defaultMuted = true;
          this.media.playsInline = true;
          this.media.loop = true;
          this.media.controls = false;
          this.media.preload = 'none';
          this.media.addEventListener('playing', () => {
            if (!this.shouldPlay()) { this.stop(); return; }
            this.setAttribute('data-playing', ''); this.label();
          }, { signal: this.events.signal });
        } else {
          this.media.addEventListener('load', () => {
            if (this.shouldPlay()) { this.setAttribute('data-playing', ''); this.label(); }
          }, { signal: this.events.signal });
        }
        this.media.addEventListener('error', () => {
          this.blocked = true; this.stop();
        }, { signal: this.events.signal });
        this.querySelector('.wbp-motion__frame').append(this.media);
      }
      if (this.media.tagName === 'VIDEO') {
        this.media.autoplay = true;
        this.media.play().then(() => {
          if (!this.shouldPlay()) this.stop();
        }).catch(() => { this.blocked = true; this.stop(); });
      } else if (this.media.complete && this.media.naturalWidth) {
        this.setAttribute('data-playing', ''); this.label();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.preference?.removeEventListener('change', this.preferenceChanged);
      this.events?.abort();
      if (this.media?.tagName === 'VIDEO') this.media.pause();
      this.media?.remove();
      this.media = null;
      this.events = null;
      this.removeAttribute('data-playing');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbp-demo-02"]) return;
  try {
    
// Only upgrades WBP's dedicated media elements. No global theme selectors.
if (!customElements.get('wbp-motion-media')) {
  customElements.define('wbp-motion-media', class extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template[data-wbp-motion]');
      this.button = this.querySelector('[data-wbp-toggle]');
      if (!this.template || !this.button || this.events) return;
      this.events = new AbortController();
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.near = false;
      this.userPaused = false;
      this.userRequested = false;
      this.blocked = false;
      this.preferenceChanged = () => { this.userRequested = false; this.sync(); };
      this.preference.addEventListener('change', this.preferenceChanged);
      document.addEventListener('visibilitychange', () => this.sync(), { signal: this.events.signal });
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        if (this.hasAttribute('data-playing')) {
          this.userPaused = true;
          this.userRequested = false;
        } else {
          this.userPaused = false;
          this.userRequested = true;
          this.blocked = false;
          this.near = true;
        }
        this.sync();
      }, { signal: this.events.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.near = entries[0].isIntersecting;
          this.sync();
        }, { rootMargin: '80px 0px', threshold: 0.01 });
        this.observer.observe(this);
      }
      this.label();
    }
    shouldPlay() {
      return this.isConnected && this.near && !document.hidden && !this.userPaused && !this.blocked &&
        (!this.preference.matches || this.userRequested);
    }
    label() {
      const playing = this.hasAttribute('data-playing');
      this.button.textContent = playing ? 'Animation pausieren' : 'Animation abspielen';
      this.button.setAttribute('aria-label', this.button.textContent);
    }
    stop() {
      this.removeAttribute('data-playing');
      if (this.media?.tagName === 'VIDEO') { this.media.autoplay = false; this.media.pause(); }
      else if (this.media) { this.media.remove(); this.media = null; }
      this.label();
    }
    sync() {
      if (!this.shouldPlay()) { this.stop(); return; }
      if (!this.media) {
        this.media = this.template.content.firstElementChild.cloneNode(true);
        this.media.classList.add('wbp-motion__live');
        if (this.media.tagName === 'VIDEO') {
          this.media.muted = true;
          this.media.defaultMuted = true;
          this.media.playsInline = true;
          this.media.loop = true;
          this.media.controls = false;
          this.media.preload = 'none';
          this.media.addEventListener('playing', () => {
            if (!this.shouldPlay()) { this.stop(); return; }
            this.setAttribute('data-playing', ''); this.label();
          }, { signal: this.events.signal });
        } else {
          this.media.addEventListener('load', () => {
            if (this.shouldPlay()) { this.setAttribute('data-playing', ''); this.label(); }
          }, { signal: this.events.signal });
        }
        this.media.addEventListener('error', () => {
          this.blocked = true; this.stop();
        }, { signal: this.events.signal });
        this.querySelector('.wbp-motion__frame').append(this.media);
      }
      if (this.media.tagName === 'VIDEO') {
        this.media.autoplay = true;
        this.media.play().then(() => {
          if (!this.shouldPlay()) this.stop();
        }).catch(() => { this.blocked = true; this.stop(); });
      } else if (this.media.complete && this.media.naturalWidth) {
        this.setAttribute('data-playing', ''); this.label();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.preference?.removeEventListener('change', this.preferenceChanged);
      this.events?.abort();
      if (this.media?.tagName === 'VIDEO') this.media.pause();
      this.media?.remove();
      this.media = null;
      this.events = null;
      this.removeAttribute('data-playing');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbp-sticky-atc"]) return;
  try {
    
  // Only this template instantiates the controller. Native Shopify forms own all cart requests.
  class WbpPurchaseSync extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.generation = 0;
      this.pending = false;
      this.busy = false;
      this.heroPassed = false;
      this.finalNear = false;
      this.footerNear = false;
      this.mobile = matchMedia('(max-width: 749px)');
      this.button = this.querySelector('.wbp-sticky-atc__button');
      this.price = this.querySelector('.wbp-sticky-atc__price');
      this.activeRoot = document.querySelector('.wbp-purchase');
      const options = { signal:this.abort.signal };
      document.addEventListener('shopify:product:select', e => this.select(e), { ...options, capture:true });
      document.addEventListener('change', e => {
        const root = e.target.closest('.wbp-purchase, .wbp-final-cta');
        if (root && e.target.matches('[name="quantity"]')) { this.activeRoot = root; this.refresh(); }
      }, options);
      document.addEventListener('shopify:cart:lines-update', e => this.cartSettled(e), options);
      document.addEventListener('shopify:cart:error', () => { this.busy = false; this.refresh(); }, options);
      this.mobile.addEventListener('change', () => this.visibility(), options);
      this.button.addEventListener('click', () => {
        this.refresh();
        if (this.button.disabled || this.pending || this.busy) return;
        const native = this.activeRoot?.querySelector('product-form-component [name="add"]');
        if (!native || native.disabled) return;
        this.busy = true;
        this.refresh();
        native.click();
        // Native validation can stop a submission before a cart event exists.
        clearTimeout(this.busyTimeout);
        this.busyTimeout = setTimeout(() => { this.busy = false; this.refresh(); }, 12000);
      }, options);
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === this.heroAnchor) this.heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          if (entry.target === this.finalAnchor) this.finalNear = entry.isIntersecting;
          if (entry.target === this.footerAnchor) this.footerNear = entry.isIntersecting;
        }
        this.visibility();
      }, { rootMargin:'0px 0px 150px 0px' });
      this.heroAnchor = document.querySelector('.wbp-purchase .buy-buttons-block') || this.activeRoot;
      this.finalAnchor = document.querySelector('.wbp-final-cta__purchase');
      this.footerAnchor = document.querySelector('footer');
      [this.heroAnchor,this.finalAnchor,this.footerAnchor].filter(Boolean).forEach(el => this.observer.observe(el));
      // Observe changes, not scrolling. Hide for known cookie/chat overlays and open native drawers.
      this.mutations = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.patchPickers(); this.visibility(); });
      });
      this.mutations.observe(document.body, { subtree:true, childList:true, attributes:true, attributeFilter:['open','hidden','aria-hidden','style'] });
      customElements.whenDefined('variant-picker').then(() => { if (this.isConnected) this.patchPickers(); });
      this.refresh();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.mutations?.disconnect();
      cancelAnimationFrame(this.frame); clearTimeout(this.busyTimeout);
      for (const picker of this.pickers || []) {
        if (picker.wbpOriginalUpdate) { picker.updateVariantPicker = picker.wbpOriginalUpdate; delete picker.wbpOriginalUpdate; }
      }
    }
    roots() { return [...document.querySelectorAll('.wbp-purchase, .wbp-final-cta')]; }
    scope(html, section) { return html?.querySelector('#' + CSS.escape(section.id)) || html; }
    patchPickers() {
      this.pickers = this.roots().flatMap(root => [...root.querySelectorAll('variant-picker')]);
      for (const picker of this.pickers) {
        if (picker.wbpOriginalUpdate || !picker.updateVariantPicker) continue;
        picker.wbpOriginalUpdate = picker.updateVariantPicker;
        const section = picker.closest('.shopify-section');
        picker.updateVariantPicker = html => picker.wbpOriginalUpdate.call(picker, this.scope(html, section));
      }
    }
    select(event) {
      if (event.wbpBridged) return;
      const root = event.target.closest?.('.wbp-purchase, .wbp-final-cta');
      if (!root || !event.promise) return;
      const source = root.closest('.shopify-section');
      const original = event.promise;
      const generation = ++this.generation;
      this.pending = true;
      this.activeRoot = root;
      this.refresh();
      const scopedPromise = section => original.then(result => {
        if (generation !== this.generation) throw new DOMException('Superseded selection', 'AbortError');
        return { ...result, detail:{ ...result.detail, html:this.scope(result.detail.html, section) } };
      });
      event.promise = scopedPromise(source);
      const peers = this.roots().filter(other => other !== root);
      for (const peer of peers) {
        const section = peer.closest('.shopify-section');
        const bridge = new Event(event.type, { bubbles:false });
        Object.assign(bridge, { wbpBridged:true, promise:scopedPromise(section), product:event.product, selectedOptions:event.selectedOptions });
        section.dispatchEvent(bridge);
      }
      original.then(result => {
        if (generation !== this.generation) return;
        for (const peer of peers) {
          const picker = peer.querySelector('variant-picker');
          picker?.updateVariantPicker(this.scope(result.detail.html, peer.closest('.shopify-section')));
        }
        this.available = Boolean(result.detail.resource?.available);
        const image = this.querySelector('.wbp-sticky-atc__image');
        const src = result.detail.resource?.featured_media?.preview_image?.src;
        if (image && src) { const url = new URL(src, location.origin); url.searchParams.set('width','100'); image.removeAttribute('srcset'); image.src = url.href; }
        requestAnimationFrame(() => { if (generation !== this.generation) return; this.pending = false; this.refresh(); });
      }).catch(() => {
        if (generation !== this.generation) return;
        this.pending = false; this.available = false; this.refresh();
      });
    }
    cartSettled(event) {
      Promise.resolve(event.promise).catch(() => {}).finally(() => {
        this.busy = false; clearTimeout(this.busyTimeout); this.refresh();
      });
    }
    refresh() {
      if (!this.activeRoot?.isConnected) this.activeRoot = document.querySelector('.wbp-purchase');
      const form = this.activeRoot?.querySelector('product-form-component');
      const native = form?.querySelector('[name="add"]');
      const id = form?.querySelector('[name="id"]');
      this.dataset.currentVariantId = id?.value || '';
      const amount = this.activeRoot?.querySelector('product-price .price')?.textContent.trim();
      if (amount && this.price.textContent !== amount) this.price.textContent = amount;
      this.button.disabled = this.pending || this.busy || this.available === false || !id?.value || !native || native.disabled;
      const label = this.pending ? 'Bitte warten …' : this.busy ? 'Wird hinzugefügt …' : this.button.disabled ? 'Nicht verfügbar' : 'In den Warenkorb';
      if (this.button.textContent !== label) this.button.textContent = label;
      this.visibility();
    }
    overlayVisible() {
      if (customElements.get('shopify-chat') && document.querySelector('shopify-chat')) return true;
      return [...document.querySelectorAll('dialog[open], #shopify-pc__banner, #shopify-pc__prefs, [data-cookie-banner]')].some(el => {
        const rect = el.getBoundingClientRect();
        const css = getComputedStyle(el);
        return !el.hidden && el.getAttribute('aria-hidden') !== 'true' && css.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
      });
    }
    visibility() {
      const hide = this.dataset.enabled !== 'true' || !this.mobile?.matches || !this.heroPassed || this.finalNear || this.footerNear || this.overlayVisible();
      if (this.hidden !== hide) this.hidden = hide;
    }
  }
  if (!customElements.get('wbp-purchase-sync')) customElements.define('wbp-purchase-sync', WbpPurchaseSync);

  } catch(e) { console.error(e); }
})();
})();
